import React from 'react';
import { Step1PresentationRecord } from '../types/step1Presentation';
import styles from '../styles/stepCommon.module.css';

interface Step1PresentationFieldsProps {
  value: Step1PresentationRecord;
  onChange: (next: Step1PresentationRecord) => void;
  disabled?: boolean;
}

const Step1PresentationFields: React.FC<Step1PresentationFieldsProps> = ({
  value,
  onChange,
  disabled = false,
}) => {
  const patch = (fields: Partial<Step1PresentationRecord>) => {
    onChange({ ...value, ...fields });
  };

  return (
    <div className={styles.actionFieldsPanel}>
      <div className={styles.actionFieldGroup}>
        <div className={styles.actionFieldRow}>
          <label className={styles.actionFieldLabel} htmlFor="step1-presented-date">
            Date presented
          </label>
          <input
            id="step1-presented-date"
            type="date"
            className={styles.actionFieldInput}
            value={value.presentedDate || ''}
            onChange={(e) => patch({ presentedDate: e.target.value })}
            disabled={disabled}
          />
        </div>
        <div className={styles.actionFieldRow}>
          <label className={styles.actionFieldLabel} htmlFor="step1-presented-place">
            Place
          </label>
          <input
            id="step1-presented-place"
            type="text"
            className={styles.actionFieldInput}
            value={value.place || ''}
            onChange={(e) => patch({ place: e.target.value })}
            placeholder="e.g. Tuesday night meeting"
            disabled={disabled}
            maxLength={200}
          />
        </div>
        <div className={styles.actionFieldRow}>
          <label className={styles.actionFieldLabel} htmlFor="step1-presented-reflection">
            How it went
          </label>
          <textarea
            id="step1-presented-reflection"
            className={styles.actionFieldTextarea}
            value={value.reflection || ''}
            onChange={(e) => patch({ reflection: e.target.value })}
            placeholder="How you felt after presenting"
            rows={2}
            disabled={disabled}
            maxLength={2000}
          />
        </div>
      </div>
    </div>
  );
};

export default Step1PresentationFields;
